import React, { useCallback, useEffect, useState } from 'react'
import DefaultCrudForm from '../DefaultCrudForm'

import { useNavigate, useSearchParams } from 'react-router-dom';

import useNotification from 'notification';
export default function DefaultEntityCrud({ EntityClass, initialValues: initialValuesProp, children, overSaveValues, posSaveAction, initialize, ...othersProps }) {
    const navigate = useNavigate();
    const [initialValues, setInitialValues] = useState(EntityClass.getInitialValues)
    const { showSuccess, showWarning } = useNotification()
    const [searchParams] = useSearchParams();
    const searchUid = searchParams.get("uid")

    // console.log('initialValues AAAAAAA', initialValues)
    const setNewValues = useCallback(() => {
        setInitialValues(EntityClass.getInitialValues)
    }, [EntityClass])

    useEffect(() => {
        let observer = null
        console.log('start Tela', searchUid)
        if (searchUid) {
            // console.log('start observer', searchUid)
            observer = EntityClass.onSnapshot(searchUid, (obj) => {
                // console.log('obj', obj)
                setInitialValues(obj)
            })
        } else {
            // setInitialValues(initialValuesProp)
        }

        return () => {
            if (observer) {
                console.log('remove observer', searchUid)
                observer()
            }
        }
    }, [EntityClass, initialValuesProp, searchUid])


    const saveValues = (values) => {
        if (overSaveValues) {
            overSaveValues(values)
        } else {
            let entity = new EntityClass()
            entity.update(values);
            entity.save().then(() => {
                // console.log('salvou')
                showSuccess("Salvo com Sucesso")
                if (posSaveAction) posSaveAction()
                navigate("/" + othersProps.routeForm + "?uid=" + entity.data.uid);

            })
        }

    }
    const validValues = async (values) => {
        let errors = await EntityClass.validFieldErrors(values)

        if (errors) {
            console.log("errors", errors)
            if (errors.length) {
                showWarning(`${errors?.join("; ")}`)
                return false
            }
        }

        return true;
    }


    return (<DefaultCrudForm saveValues={saveValues} validValues={validValues} initialValues={initialValues} setNewValues={setNewValues} {...othersProps}>
        {(formProps) => children(formProps)}
    </DefaultCrudForm>

    )
}